import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunction from "../Data.Function/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dMonoid from "../Data.Monoid/index.js";
import * as Data$dMultiSet from "../Data.MultiSet/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dSemiring from "../Data.Semiring/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dString$dCommon from "../Data.String.Common/index.js";
import * as Data$dTime$dLocal from "../Data.Time.Local/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as Record$dExtra from "../Record.Extra/index.js";
import * as Restaumatic$dAnalytics$dTypes$dItemList from "../Restaumatic.Analytics.Types.ItemList/index.js";
import * as Restaumatic$dCart$dProductKey from "../Restaumatic.Cart.ProductKey/index.js";
import * as Restaumatic$dForm$dAction from "../Restaumatic.Form.Action/index.js";
import * as Restaumatic$dForm$dFinal from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic$dForm$dFormField from "../Restaumatic.Form.FormField/index.js";
import * as Restaumatic$dForm$dInternal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic$dForm$dList from "../Restaumatic.Form.List/index.js";
import * as Restaumatic$dForm$dMapping from "../Restaumatic.Form.Mapping/index.js";
import * as Restaumatic$dForm$dReadOnly from "../Restaumatic.Form.ReadOnly/index.js";
import * as Restaumatic$dForm$dTotality from "../Restaumatic.Form.Totality/index.js";
import * as Restaumatic$dForm$dWidgets from "../Restaumatic.Form.Widgets/index.js";
import * as Restaumatic$dForm$dWidgets$dBootstrap from "../Restaumatic.Form.Widgets.Bootstrap/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dCurrency from "../Restaumatic.I18n.Currency/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dI18n$dTypes from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic$dMenu$dV2$dCreator from "../Restaumatic.Menu.V2.Creator/index.js";
import * as Restaumatic$dMenu$dV2$dEnv from "../Restaumatic.Menu.V2.Env/index.js";
import * as Restaumatic$dMenu$dV2$dMenuCatalogue from "../Restaumatic.Menu.V2.MenuCatalogue/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dModifier from "../Restaumatic.Menu.V2.Types.Modifier/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dOrderOrigin from "../Restaumatic.Menu.V2.Types.OrderOrigin/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dTags from "../Restaumatic.Menu.V2.Types.Tags/index.js";
import * as Restaumatic$dPrelude$dSpecular from "../Restaumatic.Prelude.Specular/index.js";
import * as Restaumatic$dPrelude$dSpecularExtra from "../Restaumatic.Prelude.SpecularExtra/index.js";
import * as Restaumatic$dSite$dComponents$dCart$dIntegration$dCommon from "../Restaumatic.Site.Components.Cart.Integration.Common/index.js";
import * as Restaumatic$dSite$dComponents$dCrossSelling from "../Restaumatic.Site.Components.CrossSelling/index.js";
import * as Restaumatic$dSite$dComponents$dDishIcons from "../Restaumatic.Site.Components.DishIcons/index.js";
import * as Restaumatic$dSite$dI18n from "../Restaumatic.Site.I18n/index.js";
import * as Restaumatic$dSite$dModals from "../Restaumatic.Site.Modals/index.js";
import * as Restaumatic$dSite$dTranslations$dKeys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Specular$dBootstrap$dModal from "../Specular.Bootstrap.Modal/index.js";
import * as Specular$dDom$dBrowser from "../Specular.Dom.Browser/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dDom$dWidget from "../Specular.Dom.Widget/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dExtra from "../Specular.FRP.Extra/index.js";
import * as Specular$dFRP$dHost from "../Specular.FRP.Host/index.js";
import * as Specular$dFRP$dList from "../Specular.FRP.List/index.js";
import * as Specular$dFRP$dReplaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
import * as Specular$dSelect from "../Specular.Select/index.js";
import * as Type$dEquality from "../Type.Equality/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Utils$dHash from "../Utils.Hash/index.js";
import * as Utils$dJS$dTooltip from "../Utils.JS.Tooltip/index.js";
import * as Utils$dURL from "../Utils.URL/index.js";
import {splitPizzaImageUrl} from "./foreign.js";
const productInfoChips = product => Specular$dInternal$dRIO.bindImpl(Data$dSet.foldableSet.foldr(x => {
  const $0 = (() => {
    if (x.tag === "New") {
      return Specular$dDom$dElement.el("span")([
        Specular$dDom$dElement.class_("label"),
        Specular$dDom$dElement.class_("label-success"),
        Specular$dDom$dElement.class_("label-dish"),
        Specular$dDom$dElement.class_("u-mr1")
      ])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.dish_label.new),
        {}
      )));
    }
    if (x.tag === "Recommended") {
      return Specular$dDom$dElement.el("span")([
        Specular$dDom$dElement.class_("label"),
        Specular$dDom$dElement.class_("label-info"),
        Specular$dDom$dElement.class_("label-dish"),
        Specular$dDom$dElement.class_("u-mr1")
      ])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.dish_label.recommended),
        {}
      )));
    }
    if (x.tag === "SpecialOffer") {
      return Specular$dDom$dElement.el("span")([
        Specular$dDom$dElement.class_("label"),
        Specular$dDom$dElement.class_("label-discount"),
        Specular$dDom$dElement.class_("label-dish"),
        Specular$dDom$dElement.class_("u-mr1")
      ])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.dish_label.special),
        {}
      )));
    }
    return Specular$dDom$dBuilder.monoidBuilder(Data$dMonoid.monoidUnit).mempty;
  })();
  return b => Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v => x$1 => x$1)($0))(b);
})(Specular$dInternal$dRIO.pureImpl())(Data$dRecord.unsafeGet("tags")(product)))(() => {
  const freeModifierItemsCount = Data$dMap$dInternal.foldableMap.foldl(Data$dSemiring.intAdd)(0)(Data$dMap$dInternal.functorMap.map(v => Data$dRecord.unsafeGet("freeItems")(v))(Data$dRecord.unsafeGet("modifierSettings")(product)));
  const $0 = Specular$dDom$dElement.el("span")([
    Specular$dDom$dElement.class_("label"),
    Specular$dDom$dElement.class_("label-default"),
    Specular$dDom$dElement.class_("u-mr1"),
    Specular$dDom$dElement.attr("title")(Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.dish_label.special),
      {}
    ))
  ])(Specular$dDom$dElement.text("+" + Data$dShow.showIntImpl(freeModifierItemsCount)));
  if (freeModifierItemsCount > 0) { return $0; }
  return Specular$dInternal$dRIO.pureImpl();
});
const productAvailablityWidget = localDateTime => catalogue => product => Specular$dInternal$dRIO.bindImpl((() => {
  const $0 = Specular$dInternal$dRIO.pureImpl();
  const $1 = Data$dRecord.unsafeGet("availabilitySchedule")(product);
  if ($1.tag === "Nothing") { return $0; }
  if ($1.tag === "Just") {
    return Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v => x => x)(Restaumatic$dSite$dComponents$dCart$dIntegration$dCommon.sectionItemAvailabilityBadge()()({
      catalogue,
      localDateTime,
      availabilityScheduleId: $1._1,
      showInfoIcon: false
    })))($0);
  }
  $runtime.fail();
})())(() => {
  const $0 = Specular$dDom$dElement.el("span")([Specular$dDom$dElement.classes(["m-availability", "m-availability--not-clickable"])])(Specular$dDom$dElement.el("span")([
    Specular$dDom$dElement.class_("label"),
    Specular$dDom$dElement.class_("label-dish"),
    Specular$dDom$dElement.class_("m-availability__label"),
    Specular$dDom$dElement.class_("m-availability__label--unavailable"),
    Specular$dDom$dElement.class_("u-ml1")
  ])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
    Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.menu.productTemporarilyUnavailable),
    {}
  ))));
  if (Data$dRecord.unsafeGet("availability")(product).tag === "TemporarilyUnavailable") { return $0; }
  return Specular$dInternal$dRIO.pureImpl();
});
const parameterRadioButtons = () => dictShow => dictEq => groupName => field => {
  const valueD = Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dFinal.fromValidV)(Restaumatic$dForm$dFormField.queryFormField$p1(Type$dEquality.refl).queryWith(Restaumatic$dForm$dInternal.Lax)(field));
  return Specular$dInternal$dRIO.bindImpl(Restaumatic$dForm$dWidgets$dBootstrap.displayErrors(Restaumatic$dForm$dFormField.hasErrorsFormField)(field))(() => Specular$dDom$dElement.el("div")([
    Specular$dDom$dElement.class_("m-form__group")
  ])(Specular$dFRP$dList.dynamicListWithIndex_({MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder})(Specular$dDom$dBuilder.monadReplaceBuilder)(Specular$dFRP$dBase.functorDynamic.map(Specular$dSelect.flattenOptions)(Restaumatic$dForm$dFormField.readOptions()(field)))(v => optionD => Specular$dFRP$dExtra.withUniqDynamic_({
    MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
    MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
  })(Specular$dDom$dBuilder.monadReplaceBuilder)({eq: ra => rb => ra.disabled === rb.disabled && dictEq.eq(ra.key)(rb.key) && ra.label === rb.label})(optionD)(option => {
    const checked = Specular$dFRP$dBase.functorDynamic.map(v$1 => {
      if (v$1.tag === "Nothing") { return false; }
      if (v$1.tag === "Just") { return dictEq.eq(v$1._1)(option.key); }
      return false;
    })(valueD);
    return Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("radio-inline")])(Specular$dDom$dElement.el("label")([
      Specular$dDom$dElement.class_("m-radio"),
      option.disabled ? Specular$dDom$dElement.class_("is-disabled") : Specular$dDom$dElement.monoidProp.mempty,
      Specular$dDom$dElement.classWhenD(checked)("is-selected")
    ])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("input")([
      Specular$dDom$dElement.bindChecked(Specular$dRef.$Ref(
        checked,
        fn => {
          const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(checked);
          return () => {
            const old = $0();
            if (fn(old)) {
              const handler = field.onWriteValue.value;
              return handler(field)(Restaumatic$dForm$dInternal.$TypedValue("Valid", {value: option.key, editValue: Data$dMaybe.Nothing}))();
            }
          };
        }
      )),
      Specular$dDom$dElement.attr("type")("radio"),
      Specular$dDom$dElement.classes(["m-radio__input"]),
      Specular$dDom$dElement.attr("name")(groupName),
      Specular$dDom$dElement.attr("value")(dictShow.show(option.key)),
      option.disabled ? Specular$dDom$dElement.attr("disabled")("disabled") : Specular$dDom$dElement.monoidProp.mempty
    ])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([
      Specular$dDom$dElement.class_("m-radio__icon-state"),
      Specular$dDom$dElement.attr("aria-hidden")("true")
    ])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dDom$dElement.text(option.label)))));
  }))));
};
const parametersField = dictIsPartId => locale => catalogue => partIdF => f => Specular$dFRP$dExtra.withUniqDynamic_({
  MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
  MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
})(Specular$dDom$dBuilder.monadReplaceBuilder)((() => {
  const $0 = dictIsPartId.Eq0();
  return {
    eq: x => y => {
      if (x.tag === "Nothing") { return y.tag === "Nothing"; }
      if (x.tag === "Just") {
        if (y.tag === "Just") { return $0.eq(x._1)(y._1); }
        return false;
      }
      return false;
    }
  };
})())(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dFinal.fromValidV)(partIdF))(m_partId => {
  const $0 = Specular$dInternal$dRIO.pureImpl();
  if (m_partId.tag === "Nothing") { return $0; }
  if (m_partId.tag === "Just") {
    const $1 = m_partId._1;
    return Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v => x => x)(Restaumatic$dForm$dMapping.display(Data$dOrd.ordString)({
      MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
      MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
    })(Specular$dDom$dBuilder.monadReplaceBuilder)(f)(item => {
      const $2 = Specular$dInternal$dRIO.pureImpl();
      const $3 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(item.key)(Data$dRecord.unsafeGet("customParameters")(catalogue));
      if ($3.tag === "Nothing") { return $2; }
      if ($3.tag === "Just") {
        return Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v => x => x)(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("row")])(Specular$dDom$dElement.el("fieldset")([
          Specular$dDom$dElement.class_("col-md-12"),
          Specular$dDom$dElement.classWhenD(Restaumatic$dForm$dInternal.hasDisplayedErrors(Restaumatic$dForm$dFormField.hasErrorsFormField)(item.subform))("has-error")
        ])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("legend")([Specular$dDom$dElement.class_("h4 u-legend-float")])(Specular$dDom$dElement.text(Restaumatic$dI18n$dTypes.getLocalization(locale)($3._1.name))))(() => parameterRadioButtons()(Data$dUUID.showUUID)(Data$dEq.eqString)(dictIsPartId.partIdToName($1) + ".parameters." + item.key)(item.subform))))))($2);
      }
      $runtime.fail();
    })))($0);
  }
  $runtime.fail();
});
const modifierButtons = dictIsPartId => partId => modifierId => sections => v => {
  const $0 = v.extra;
  const groupName = dictIsPartId.partIdToName(partId) + ".modifiers." + modifierId;
  const multisetD = Restaumatic$dForm$dInternal.queryLaxWithDefault(Restaumatic$dForm$dFormField.queryFormField$p1(Type$dEquality.refl))(Data$dMap$dInternal.Leaf)(v.subform);
  return Specular$dFRP$dExtra.withUniqDynamic_({MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder})(Specular$dDom$dBuilder.monadReplaceBuilder)(Restaumatic$dMenu$dV2$dTypes$dModifier.eqModifierDisplayMode)(Restaumatic$dForm$dInternal.unFinalWithDefault(Restaumatic$dMenu$dV2$dTypes$dModifier.ModifierList)(Restaumatic$dForm$dReadOnly.queryReadOnly$p1(Type$dEquality.refl).queryWith(Restaumatic$dForm$dInternal.Strict)($0.actualDisplayMode)))(actualDisplayMode => Data$dFoldable.foldrArray(x => {
    const $1 = Specular$dDom$dElement.el("fieldset")([Specular$dDom$dElement.classes(actualDisplayMode.tag === "ModifierPizzaGrid" ? ["row", "topping-group"] : ["row"])])(Specular$dDom$dElement.el("div")([
      Specular$dDom$dElement.class_("col-md-12")
    ])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("legend")([Specular$dDom$dElement.classes(["topping-group-name", "h5"])])(Specular$dDom$dElement.text(x.name)))(() => Specular$dDom$dElement.el("div")([
      Specular$dDom$dElement.classes(actualDisplayMode.tag === "ModifierPizzaGrid" ? ["row", "row--flex", "topping-row", "m-form__group"] : ["m-form__group"])
    ])(Data$dFoldable.foldrArray(x$1 => {
      const priceTextD = Specular$dFRP$dBase.functorDynamic.map(v2 => {
        if (v2.tag === "Nothing") { return ""; }
        if (v2.tag === "Just") { return " (+" + Restaumatic$dI18n$dCurrency.formatCurrency(Restaumatic$dSite$dI18n.getGlobalCurrency())(v2._1) + ")"; }
        $runtime.fail();
      })(x$1.price);
      const iconAndName = Specular$dInternal$dRIO.bindImpl((() => {
        const $1 = Specular$dInternal$dRIO.pureImpl();
        if (x$1.photo.tag === "Nothing") { return $1; }
        if (x$1.photo.tag === "Just") {
          return Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v$1 => x$2 => x$2)(Specular$dDom$dElement.el("span")([
            Specular$dDom$dElement.class_("topping__icon"),
            Specular$dDom$dElement.attr("style")("background-image: url(\"" + Utils$dURL.imgixUrl + x$1.photo._1 + "\")")
          ])(Restaumatic$dPrelude$dSpecular.wempty)))($1);
        }
        $runtime.fail();
      })())(() => Specular$dDom$dElement.el("span")([Specular$dDom$dElement.class_("topping__name")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(x$1.name + " "))(() => Specular$dDom$dElement.el("span")([
        Specular$dDom$dElement.class_("topping__price")
      ])(Specular$dDom$dElement.dynText(priceTextD)))));
      const $1 = (() => {
        if (actualDisplayMode.tag === "ModifierHidden") { return Restaumatic$dPrelude$dSpecular.wempty; }
        if (actualDisplayMode.tag === "ModifierRadioButtonList") {
          const checked = Specular$dFRP$dBase.functorDynamic.map((() => {
            const $1 = Data$dMultiSet.occur(Data$dOrd.ordString)(x$1.id);
            return x$2 => $1(x$2) > 0;
          })())(multisetD);
          return Specular$dDom$dElement.el("label")([
            Specular$dDom$dElement.classes(["m-radio", "m-radio--option"]),
            Specular$dDom$dElement.classWhenD(checked)("is-selected"),
            Specular$dDom$dElement.classWhenD(x$1.disabled)("is-disabled"),
            Specular$dDom$dElement.attrUnlessD(x$1.visible)("style")("display: none")
          ])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("input")([
            Specular$dDom$dElement.bindChecked(Specular$dRef.$Ref(
              checked,
              fn => {
                const $1 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(checked);
                return () => {
                  const old = $1();
                  const $2 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)($0.selectOnlyItem.effect._1);
                  if (fn(old)) {
                    const e = $2();
                    return e(x$1.id)();
                  }
                };
              }
            )),
            Specular$dDom$dElement.attr("type")("radio"),
            Specular$dDom$dElement.classes(["m-radio__input"]),
            Specular$dDom$dElement.attr("name")(groupName),
            Specular$dDom$dElement.attr("value")(x$1.id)
          ])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([
            Specular$dDom$dElement.class_("m-radio__icon-state"),
            Specular$dDom$dElement.attr("aria-hidden")("true")
          ])(Restaumatic$dPrelude$dSpecular.wempty))(() => iconAndName)));
        }
        if (actualDisplayMode.tag === "ModifierCheckboxList") {
          const checked = Specular$dFRP$dBase.functorDynamic.map((() => {
            const $1 = Data$dMultiSet.occur(Data$dOrd.ordString)(x$1.id);
            return x$2 => $1(x$2) > 0;
          })())(multisetD);
          return Specular$dDom$dElement.el("label")([
            Specular$dDom$dElement.classes(["m-checkbox", "m-checkbox--option"]),
            Specular$dDom$dElement.classWhenD(checked)("is-selected"),
            Specular$dDom$dElement.classWhenD(x$1.disabled)("is-disabled"),
            Specular$dDom$dElement.attrUnlessD(x$1.visible)("style")("display: none")
          ])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("input")([
            Specular$dDom$dElement.bindChecked(Specular$dRef.$Ref(
              checked,
              fn => {
                const $1 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(checked);
                return () => {
                  const old = $1();
                  const e = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)($0.setItemSelected.effect._1)();
                  return e(Data$dTuple.$Tuple(x$1.id, fn(old)))();
                };
              }
            )),
            Specular$dDom$dElement.attr("type")("checkbox"),
            Specular$dDom$dElement.classes(["m-checkbox__input"]),
            Specular$dDom$dElement.attr("name")(groupName),
            Specular$dDom$dElement.attr("value")(x$1.id)
          ])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([
            Specular$dDom$dElement.class_("m-checkbox__icon-state"),
            Specular$dDom$dElement.attr("aria-hidden")("true")
          ])(Restaumatic$dPrelude$dSpecular.wempty))(() => iconAndName)));
        }
        if (actualDisplayMode.tag === "ModifierList") {
          const countD = Specular$dFRP$dBase.functorDynamic.map(Data$dMultiSet.occur(Data$dOrd.ordString)(x$1.id))(multisetD);
          return Specular$dDom$dElement.el("div")([
            Specular$dDom$dElement.classes(["m-modifier-item"]),
            Specular$dDom$dElement.classWhenD(Specular$dFRP$dBase.functorDynamic.map((() => {
              const $1 = Data$dMultiSet.occur(Data$dOrd.ordString)(x$1.id);
              return x$2 => $1(x$2) > 0;
            })())(multisetD))("is-selected"),
            Specular$dDom$dElement.classWhenD(x$1.disabled)("is-disabled"),
            Specular$dDom$dElement.attrUnlessD(x$1.visible)("style")("display: none")
          ])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("m-modifier-item__stepper")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("button")([
            Specular$dDom$dElement.class_("m-modifier-item__btn"),
            Specular$dDom$dElement.attr("type")("button"),
            Restaumatic$dPrelude$dSpecularExtra.onClickPreventDefault_((() => {
              const $1 = x$1.id;
              return b => {
                const $2 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)($0.decreaseItem.effect._1);
                return () => {
                  const e = $2();
                  return e($1)();
                };
              };
            })()),
            Specular$dDom$dElement.attr("data-testid")(groupName + "." + x$1.id + ".decrease"),
            Specular$dDom$dElement.attrD("aria-label")(Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(v1 => v2 => Restaumatic$dI18n._translate(
              Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.creator.stepper.decrease),
              {
                name: Data$dShow.showStringImpl(x$1.name),
                from: Data$dShow.showIntImpl(v1),
                to: Data$dShow.showIntImpl(v1 - 1 | 0),
                price: (() => {
                  if (v2.tag === "Nothing") { return ""; }
                  if (v2.tag === "Just") { return " (-" + Restaumatic$dI18n$dCurrency.formatCurrency(Restaumatic$dSite$dI18n.getGlobalCurrency())(v2._1) + ")"; }
                  $runtime.fail();
                })()
              }
            ))(countD))(x$1.price)),
            Specular$dDom$dElement.attrUnlessD(x$1.canDecrease)("disabled")("disabled")
          ])(Specular$dDom$dElement.el("span")([
            Specular$dDom$dElement.attrs(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
              const $1 = {};
              $1.class = "icon-minus icon-flex-center";
              return $1;
            })())((() => {
              const $1 = {};
              $1["aria-hidden"] = "true";
              return $1;
            })()))
          ])(Restaumatic$dPrelude$dSpecular.wempty)))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([
            Specular$dDom$dElement.class_("m-modifier-item__count")
          ])(Specular$dDom$dElement.dynText(Specular$dFRP$dBase.functorDynamic.map(Data$dShow.showIntImpl)(countD))))(() => Specular$dDom$dElement.el("button")([
            Specular$dDom$dElement.class_("m-modifier-item__btn"),
            Specular$dDom$dElement.attr("type")("button"),
            Restaumatic$dPrelude$dSpecularExtra.onClickPreventDefault_((() => {
              const $1 = x$1.id;
              return b => {
                const $2 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)($0.increaseItem.effect._1);
                return () => {
                  const e = $2();
                  return e($1)();
                };
              };
            })()),
            Specular$dDom$dElement.attr("data-testid")(groupName + "." + x$1.id + ".increase"),
            Specular$dDom$dElement.attrD("aria-label")(Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(v1 => v2 => Restaumatic$dI18n._translate(
              Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.creator.stepper.increase),
              {
                name: Data$dShow.showStringImpl(x$1.name),
                from: Data$dShow.showIntImpl(v1),
                to: Data$dShow.showIntImpl(v1 + 1 | 0),
                price: (() => {
                  if (v2.tag === "Nothing") { return ""; }
                  if (v2.tag === "Just") { return " (+" + Restaumatic$dI18n$dCurrency.formatCurrency(Restaumatic$dSite$dI18n.getGlobalCurrency())(v2._1) + ")"; }
                  $runtime.fail();
                })()
              }
            ))(countD))(x$1.price)),
            Specular$dDom$dElement.attrUnlessD(x$1.canIncrease)("disabled")("disabled")
          ])(Specular$dDom$dElement.el("span")([
            Specular$dDom$dElement.attrs(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
              const $1 = {};
              $1.class = "icon-plus icon-flex-center";
              return $1;
            })())((() => {
              const $1 = {};
              $1["aria-hidden"] = "true";
              return $1;
            })()))
          ])(Restaumatic$dPrelude$dSpecular.wempty))))))(() => Specular$dDom$dElement.el("span")([Specular$dDom$dElement.class_("m-modifier-item__name")])(iconAndName)));
        }
        if (actualDisplayMode.tag === "ModifierPizzaGrid") {
          const pizzaIconAndName = Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([
            Specular$dDom$dElement.class_("topping__icon"),
            x$1.photo.tag === "Just"
              ? Specular$dDom$dElement.attr("style")("background-image: url(\"" + Utils$dURL.imgixUrl + x$1.photo._1 + "\")")
              : Specular$dDom$dElement.monoidProp.mempty
          ])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dDom$dElement.el("span")([Specular$dDom$dElement.class_("topping__name")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(x$1.name + " "))(() => Specular$dDom$dElement.el("span")([
            Specular$dDom$dElement.class_("topping__price")
          ])(Specular$dDom$dElement.dynText(Specular$dFRP$dBase.functorDynamic.map(v2 => {
            if (v2.tag === "Nothing") { return ""; }
            if (v2.tag === "Just") { return "(+" + Restaumatic$dI18n$dCurrency.formatCurrency(Restaumatic$dSite$dI18n.getGlobalCurrency())(v2._1) + ")"; }
            $runtime.fail();
          })(x$1.price))))));
          return Specular$dDom$dElement.el("div")([
            Specular$dDom$dElement.classes(["col-xs-6", "col-sm-4", "col-md-3", "topping-item"]),
            Specular$dDom$dElement.classWhenD(Specular$dFRP$dBase.functorDynamic.map((() => {
              const $1 = Data$dMultiSet.occur(Data$dOrd.ordString)(x$1.id);
              return x$2 => $1(x$2) > 0;
            })())(multisetD))("is-selected"),
            Specular$dDom$dElement.classWhenD(x$1.disabled)("is-disabled"),
            Specular$dDom$dElement.attrUnlessD(x$1.visible)("style")("display: none")
          ])(Specular$dDom$dElement.el("button")([
            Specular$dDom$dElement.class_("topping"),
            Specular$dDom$dElement.attr("type")("button"),
            Restaumatic$dPrelude$dSpecularExtra.onClickPreventDefault_((() => {
              const $1 = x$1.id;
              return b => {
                const $2 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)($0.toggleItem.effect._1);
                return () => {
                  const e = $2();
                  return e($1)();
                };
              };
            })()),
            Specular$dDom$dElement.attr("data-testid")(groupName + "." + x$1.id)
          ])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([Specular$dDom$dElement.class_("topping__count")])(Specular$dDom$dElement.dynText(Specular$dFRP$dBase.functorDynamic.map((() => {
            const $1 = Data$dMultiSet.occur(Data$dOrd.ordString)(x$1.id);
            return x$2 => {
              const $2 = $1(x$2);
              if ($2 === 0) { return ""; }
              return Data$dShow.showIntImpl($2) + "x";
            };
          })())(multisetD))))(() => pizzaIconAndName)));
        }
        $runtime.fail();
      })();
      return b => Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v$1 => x$2 => x$2)($1))(b);
    })(Specular$dInternal$dRIO.pureImpl())(x.items)))));
    return b => Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v$1 => x$1 => x$1)($1))(b);
  })(Specular$dInternal$dRIO.pureImpl())(sections));
};
const hideModal = Specular$dBootstrap$dModal.hideModalBs5;
const emptyMenuEnv = Restaumatic$dMenu$dV2$dEnv.emptyMenuEnv;
const effectCallback = effect => v => {
  const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(effect);
  return () => {
    const x = $0();
    return x();
  };
};
const onClickD = effect => Restaumatic$dPrelude$dSpecularExtra.onClickPreventDefault_(effectCallback(effect));
const displayModifierChoices = locale => modifier => choices => Data$dFoldable.foldlArray(v => x => {
  if (v.init) { return {init: false, acc: x}; }
  return {init: false, acc: v.acc + ", " + x};
})({init: true, acc: ""})(Data$dArray.mapMaybe(v => {
  const n = Data$dMultiSet.occur(Data$dOrd.ordString)(v._1)(choices);
  if (n > 0) {
    return Data$dMaybe.$Maybe(
      "Just",
      (() => {
        const $0 = n > 1;
        const $1 = " (x" + Data$dShow.showIntImpl(n) + ")";
        return Restaumatic$dI18n$dTypes.getLocalization(locale)(v._2.name) + (() => {
          if (!$0) { return ""; }
          if ($0) { return $1; }
          $runtime.fail();
        })();
      })()
    );
  }
  return Data$dMaybe.Nothing;
})(Restaumatic$dMenu$dV2$dMenuCatalogue.modifierItems(modifier)._2)).acc;
const modifiersField = dictIsPartId => locale => catalogue => partIdF => modifiers => Specular$dFRP$dExtra.withUniqDynamic_({
  MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
  MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
})(Specular$dDom$dBuilder.monadReplaceBuilder)((() => {
  const $0 = dictIsPartId.Eq0();
  return {
    eq: x => y => {
      if (x.tag === "Nothing") { return y.tag === "Nothing"; }
      if (x.tag === "Just") {
        if (y.tag === "Just") { return $0.eq(x._1)(y._1); }
        return false;
      }
      return false;
    }
  };
})())(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dFinal.fromValidV)(partIdF))((() => {
  const $0 = Specular$dInternal$dRIO.pureImpl();
  return v1 => {
    if (v1.tag === "Nothing") { return $0; }
    if (v1.tag === "Just") {
      const $1 = v1._1;
      return Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v => x => x)(Restaumatic$dForm$dMapping.display(Data$dOrd.ordString)({
        MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
        MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
      })(Specular$dDom$dBuilder.monadReplaceBuilder)(modifiers)(modifierItem => {
        const groupName = dictIsPartId.partIdToName($1) + ".modifiers." + modifierItem.key;
        const $2 = Specular$dInternal$dRIO.pureImpl();
        const $3 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(modifierItem.key)(Data$dRecord.unsafeGet("modifiers")(catalogue));
        if ($3.tag === "Nothing") { return $2; }
        if ($3.tag === "Just") {
          const $4 = $3._1;
          return Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v => x => x)(Specular$dDom$dElement.el("fieldset")([
            Specular$dDom$dElement.class_("m-form__group"),
            Specular$dDom$dElement.class_("u-mb0")
          ])(Specular$dFRP$dExtra.whenD({MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder})(Specular$dDom$dBuilder.monadReplaceBuilder)(Restaumatic$dForm$dInternal.queryLaxWithDefault(Restaumatic$dForm$dReadOnly.queryReadOnly$p1(Type$dEquality.refl))(false)(modifierItem.subform.extra.userEditableWhen))(Specular$dInternal$dRIO.bindImpl((() => {
            const $5 = Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("row")])(Specular$dDom$dElement.el("div")([
              Specular$dDom$dElement.class_("col-md-12"),
              Specular$dDom$dElement.classWhenD(Restaumatic$dForm$dInternal.hasDisplayedErrors(Restaumatic$dForm$dFormField.hasErrorsFormField)(modifierItem.subform.subform))("has-error")
            ])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("legend")([Specular$dDom$dElement.class_("h4")])(Specular$dDom$dElement.dynText(Restaumatic$dForm$dInternal.queryLaxWithDefault(Restaumatic$dForm$dReadOnly.queryReadOnly$p1(Type$dEquality.refl))("")(modifierItem.subform.extra.modifierName))))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.dynText(Restaumatic$dForm$dInternal.queryLaxWithDefault(Restaumatic$dForm$dReadOnly.queryReadOnly$p1(Type$dEquality.refl))("")(modifierItem.subform.extra.modifierDescription)))(() => Specular$dInternal$dRIO.bindImpl(Restaumatic$dForm$dWidgets$dBootstrap.displayErrors(Restaumatic$dForm$dFormField.hasErrorsFormField)(modifierItem.subform.subform))(() => Specular$dFRP$dExtra.whenD({
              MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
              MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
            })(Specular$dDom$dBuilder.monadReplaceBuilder)(Restaumatic$dForm$dInternal.queryLaxWithDefault(Restaumatic$dForm$dReadOnly.queryReadOnly$p1(Type$dEquality.refl))(false)(modifierItem.subform.extra.summaryVisible))(Specular$dDom$dElement.el_("p")(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.dynText(Specular$dFRP$dBase.functorDynamic.map(displayModifierChoices(locale)($4))(Restaumatic$dForm$dInternal.queryLaxWithDefault(Restaumatic$dForm$dFormField.queryFormField$p1(Type$dEquality.refl))(Data$dMap$dInternal.Leaf)(modifierItem.subform.subform))))(() => Specular$dFRP$dExtra.whenD({
              MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
              MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
            })(Specular$dDom$dBuilder.monadReplaceBuilder)(Restaumatic$dForm$dInternal.queryLaxWithDefault(Restaumatic$dForm$dReadOnly.queryReadOnly$p1(Type$dEquality.refl))(false)(modifierItem.subform.extra.editorToggleVisible))(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(" "))(() => Specular$dDom$dElement.el("button")([
              Specular$dDom$dElement.class_("btn-link"),
              Specular$dDom$dElement.attr("type")("button"),
              Specular$dDom$dElement.onClick_((() => {
                const $5 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(modifierItem.subform.extra.toggleEditor.effect._1);
                return () => {
                  const e = $5();
                  return e()();
                };
              })()),
              Specular$dDom$dElement.attr("data-testid")(groupName + ".toggleEditor")
            ])(Specular$dDom$dElement.dynText(Specular$dFRP$dBase.functorDynamic.map(v1$1 => {
              if (v1$1) {
                return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.creator.hide), {});
              }
              return Restaumatic$dI18n._translate(
                Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.menu.creator.actions.editModifier),
                {}
              );
            })(Restaumatic$dForm$dInternal.queryLaxWithDefault(Restaumatic$dForm$dReadOnly.queryReadOnly$p1(Type$dEquality.refl))(false)(modifierItem.subform.extra.editorVisible))))))))))))));
            if (
              $4.displayMode.tag === "ModifierList" || $4.displayMode.tag === "ModifierCheckboxList" || $4.displayMode.tag === "ModifierRadioButtonList" || $4.displayMode.tag === "ModifierPizzaGrid" || !(
                $4.displayMode.tag === "ModifierHidden"
              )
            ) {
              return $5;
            }
            return Specular$dInternal$dRIO.pureImpl();
          })())(() => Specular$dFRP$dExtra.whenD({MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder})(Specular$dDom$dBuilder.monadReplaceBuilder)(Restaumatic$dForm$dInternal.queryLaxWithDefault(Restaumatic$dForm$dReadOnly.queryReadOnly$p1(Type$dEquality.refl))(false)(modifierItem.subform.extra.editorVisible))(Specular$dFRP$dReplaceable.withDynamic_(Specular$dDom$dBuilder.monadReplaceBuilder)({
            MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
            MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
          })(Restaumatic$dForm$dInternal.queryLaxWithDefault(Restaumatic$dForm$dReadOnly.queryReadOnly$p1(Type$dEquality.refl))([])(modifierItem.subform.extra.sections))(sections => modifierButtons(dictIsPartId)($1)(modifierItem.key)(sections)(modifierItem.subform))))))))($2);
        }
        $runtime.fail();
      })))($0);
    }
    $runtime.fail();
  };
})());
const dishIcons = product => Specular$dDom$dElement.el("span")([Specular$dDom$dElement.class_("dish-icons")])(Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.rio(env => Specular$dDom$dBrowser.appendRawHtmlImpl("&nbsp;")(env.parent)))(() => Specular$dInternal$dRIO.bindImpl(Data$dSet.foldableSet.foldr(x => {
  const $0 = Specular$dInternal$dRIO.pureImpl();
  const $1 = Data$dMap$dInternal.lookup(Restaumatic$dMenu$dV2$dTypes$dTags.ordTag)(x)(Restaumatic$dSite$dComponents$dDishIcons.dishIconDescriptions);
  const $2 = (() => {
    if ($1.tag === "Nothing") { return $0; }
    if ($1.tag === "Just") {
      return Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v => x$1 => x$1)(Specular$dDom$dElement.el("span")([
        Specular$dDom$dElement.class_("dish-icons__list-item"),
        Specular$dDom$dElement.class_("js-ps-tooltip"),
        Specular$dDom$dElement.attr("title")($1._1.label()),
        Specular$dDom$dElement.attr("tabindex")("0")
      ])(Specular$dDom$dElement.el("svg")([Specular$dDom$dElement.class_($1._1.iconName), Specular$dDom$dElement.attr("style")("width: 20px; height: 20px")])((() => {
        const $2 = "<svg xmlns=\"http://www.w3.org/2000/svg\\\" height=\"20px\" viewBox=\"0 0 20 20\" width=\"20px\" fill=\"currentColor\">" + $1._1.iconSvg + "</svg>";
        return Specular$dInternal$dRIO.rio(env => Specular$dDom$dBrowser.appendRawHtmlImpl($2)(env.parent));
      })()))))($0);
    }
    $runtime.fail();
  })();
  return b => Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v => x$1 => x$1)($2))(b);
})(Specular$dInternal$dRIO.pureImpl())(Data$dRecord.unsafeGet("tags")(product)))(() => Utils$dJS$dTooltip.initPSTooltip(".js-ps-tooltip"))));
const contentView = v => f => {
  const $0 = v.catalogue;
  const locale = v.menuEnv.locale;
  return Specular$dInternal$dRIO.bindImpl(parametersField(Restaumatic$dMenu$dV2$dCreator.isPartIdPartId)(locale)($0)(Restaumatic$dForm$dFinal.applicativeFinal.pure(Restaumatic$dMenu$dV2$dCreator.ToplevelPart))(f.customParameters))(() => Specular$dInternal$dRIO.bindImpl(modifiersField(Restaumatic$dMenu$dV2$dCreator.isPartIdPartId)(locale)($0)(Restaumatic$dForm$dFinal.applicativeFinal.pure(Restaumatic$dMenu$dV2$dCreator.ToplevelPart))(f.modifiers))(() => Specular$dInternal$dRIO.bindImpl(Restaumatic$dForm$dList.displayList({
    MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
    MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
  })(Specular$dDom$dBuilder.monadReplaceBuilder)(f.parts)(indexD => item => {
    const isSplit = Restaumatic$dForm$dInternal.queryLaxWithDefault(Restaumatic$dForm$dReadOnly.queryReadOnly$p1(Type$dEquality.refl))(false)(f.displayAsParts);
    const partNumber = Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(v1 => v2 => {
      if (v2) { return Data$dMaybe.$Maybe("Just", v1 + 1 | 0); }
      return Data$dMaybe.Nothing;
    })(indexD))(isSplit);
    return Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([
      Specular$dDom$dElement.classesD(Specular$dFRP$dBase.functorDynamic.map(v1 => {
        if (v1) { return ["row", "row--flex", "flex-nowrap", "align-items-center"]; }
        return ["row"];
      })(isSplit))
    ])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("col-auto")])(Specular$dFRP$dExtra.withUniqDynamic_({
      MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
      MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
    })(Specular$dDom$dBuilder.monadReplaceBuilder)({
      eq: x => y => {
        if (x.tag === "Nothing") { return y.tag === "Nothing"; }
        if (x.tag === "Just") {
          if (y.tag === "Just") { return x._1 === y._1; }
          return false;
        }
        return false;
      }
    })(partNumber)(v1 => {
      if (v1.tag === "Just") {
        if (v1._1 === 1) {
          return Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["creator__half-ornament", "creator__half-ornament--v2"])])(Specular$dDom$dElement.el("img")([
            Specular$dDom$dElement.class_("creator__half-ornament-img"),
            Specular$dDom$dElement.attr("src")(splitPizzaImageUrl)
          ])(Restaumatic$dPrelude$dSpecular.wempty));
        }
        if (v1._1 === 2) {
          return Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["creator__half-ornament", "creator__half-ornament--v2", "creator__half-ornament--2nd"])])(Specular$dDom$dElement.el("img")([
            Specular$dDom$dElement.class_("creator__half-ornament-img"),
            Specular$dDom$dElement.attr("src")(splitPizzaImageUrl)
          ])(Restaumatic$dPrelude$dSpecular.wempty));
        }
        return Restaumatic$dPrelude$dSpecular.wempty;
      }
      return Restaumatic$dPrelude$dSpecular.wempty;
    })))(() => Specular$dDom$dElement.el("fieldset")([Specular$dDom$dElement.class_("col")])((() => {
      const productId = Data$dRecord.unsafeGet("productId")(item.subform);
      return Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dExtra.whenD({
        MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
        MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
      })(Specular$dDom$dBuilder.monadReplaceBuilder)(isSplit)(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("legend")([Specular$dDom$dElement.class_("h4")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.dynText(Specular$dFRP$dBase.functorDynamic.map(v1 => {
        if (v1.tag === "Just") {
          if (v1._1 === 1) {
            return Restaumatic$dI18n._translate(
              Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.creator.pizza_1st_half),
              {}
            );
          }
          if (v1._1 === 2) {
            return Restaumatic$dI18n._translate(
              Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.creator.pizza_2nd_half),
              {}
            );
          }
          return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.menu.creator.chooseProduct), {});
        }
        return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.menu.creator.chooseProduct), {});
      })(partNumber)))(() => Specular$dDom$dElement.el("button")([
        Specular$dDom$dElement.class_("btn-link"),
        Specular$dDom$dElement.attr("type")("button"),
        Restaumatic$dPrelude$dSpecularExtra.onClickPreventDefault_(v1 => item.delete)
      ])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.widgets.cart.remove),
        {}
      ))))))(() => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["m-form__group"])])(Specular$dDom$dElement.el("div")([
        Specular$dDom$dElement.classes(["m-select", "m-select--inline"])
      ])(Restaumatic$dForm$dWidgets.select(Data$dUUID.showUUID)(Data$dEq.eqString)({toOptionId: Data$dUUID.toString})(Restaumatic$dForm$dFormField.isSelectFieldFormField$p())([
        Specular$dDom$dElement.class_("m-select__select")
      ])(productId))))))(() => Restaumatic$dForm$dWidgets$dBootstrap.displayAlertWarning(Restaumatic$dForm$dFormField.hasErrorsFormField)(productId));
    })()))))(() => {
      const partId = Restaumatic$dForm$dReadOnly.queryReadOnly$p1(Type$dEquality.refl).queryWith(Restaumatic$dForm$dInternal.Strict)(Data$dRecord.unsafeGet("partId")(item.subform));
      return Specular$dInternal$dRIO.bindImpl(parametersField(Restaumatic$dMenu$dV2$dCreator.isPartIdPartId)(locale)($0)(partId)(Data$dRecord.unsafeGet("customParameters")(item.subform)))(() => modifiersField(Restaumatic$dMenu$dV2$dCreator.isPartIdPartId)(locale)($0)(partId)(Data$dRecord.unsafeGet("modifiers")(item.subform)));
    });
  }))(() => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dExtra.whenD({
    MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
    MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
  })(Specular$dDom$dBuilder.monadReplaceBuilder)(Restaumatic$dForm$dInternal.queryLaxWithDefault(Restaumatic$dForm$dReadOnly.queryReadOnly$p1(Type$dEquality.refl))(false)(f.canSplit))(Specular$dDom$dElement.el("div")([
    Specular$dDom$dElement.classes(["row", "m-form__group"])
  ])(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("col-md-12")])(Specular$dDom$dElement.el("button")([
    Specular$dDom$dElement.attrs(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
      const $1 = {};
      $1.type = "button";
      return $1;
    })())((() => {
      const $1 = {};
      $1.class = "btn btn-default";
      return $1;
    })())),
    Restaumatic$dPrelude$dSpecularExtra.onClickPreventDefault_(Restaumatic$dForm$dAction.triggerCb(f.split))
  ])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
    Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.menu.creator.actions.split),
    {}
  )))))))(() => Restaumatic$dForm$dWidgets$dBootstrap.displayErrors(Restaumatic$dForm$dInternal.hasErrorsErrorArray)(Restaumatic$dForm$dReadOnly.queryReadOnly$p1(Type$dEquality.refl).queryWith(Restaumatic$dForm$dInternal.Strict)(f.errors))))));
};
const creator = v => modalR => {
  const $0 = v.initialProductKey;
  const $1 = v.menu;
  const $2 = v.menuConsumer;
  const $3 = v.menuEnv;
  const $4 = v.restaurantId;
  const catalogue = Data$dRecord.unsafeGet("catalogue")($1);
  return Specular$dInternal$dRIO.bindImpl(Data$dTime$dLocal.localNow(Specular$dInternal$dRIO.monadEffectRIO)(v.timeZone))(localDateTime => Specular$dInternal$dRIO.bindImpl(Restaumatic$dI18n.getGlobalLocale(Specular$dInternal$dRIO.monadEffectRIO))(locale => Specular$dInternal$dRIO.bindImpl(Specular$dRef.new(Specular$dInternal$dRIO.monadEffectRIO)(false))(submittedRef => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dHost.liftHost(Specular$dDom$dBuilder.monadCleanupBuilder)(Specular$dInternal$dRIO.monadEffectRIO)(Restaumatic$dMenu$dV2$dCreator.init({
    catalogue,
    menuEnv: $3,
    menuConsumer: $2,
    showUnavailableInSelect: false,
    initialProductKey: $0
  })))(f => Specular$dInternal$dRIO.bindImpl((() => {
    const $5 = Restaumatic$dForm$dInternal.makeEmpty_Record()(Restaumatic$dForm$dInternal.makeEmptyRecordCons({reflectSymbol: () => "canDecrease"})(Restaumatic$dForm$dInternal.makeEmptyRecordCons({
      reflectSymbol: () => "decrease"
    })(Restaumatic$dForm$dInternal.makeEmptyRecordCons({reflectSymbol: () => "increase"})(Restaumatic$dForm$dInternal.makeEmptyRecordNil)(Restaumatic$dForm$dAction.makeEmptyAction)()())(Restaumatic$dForm$dAction.makeEmptyAction)()())(Restaumatic$dForm$dReadOnly.makeEmptyReadOnly)()());
    const $6 = {name: []};
    const $7 = Restaumatic$dForm$dFormField.unsafeNewEmptyFormField(Restaumatic$dForm$dTotality.isTotalityPartial)($6);
    return () => {
      const subform1 = $7();
      const extra1 = $5.makeEmptyImpl({name: $6.name})();
      return {subform: subform1, extra: extra1};
    };
  })())(v1 => Specular$dInternal$dRIO.bindImpl(Restaumatic$dForm$dInternal.makeEmpty_Record()(Restaumatic$dForm$dInternal.makeEmptyRecordCons({reflectSymbol: () => "finished"})(Restaumatic$dForm$dInternal.makeEmptyRecordCons({
    reflectSymbol: () => "result"
  })(Restaumatic$dForm$dInternal.makeEmptyRecordCons({reflectSymbol: () => "selections"})(Restaumatic$dForm$dInternal.makeEmptyRecordCons({reflectSymbol: () => "total"})(Restaumatic$dForm$dInternal.makeEmptyRecordNil)(Restaumatic$dForm$dReadOnly.makeEmptyReadOnly)()())(Restaumatic$dForm$dMapping.makeEmpty(Data$dOrd.ordString)(Data$dUUID.showUUID)({
    addContext: Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "add"})(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "details"})(Restaumatic$dForm$dInternal.addContextRecordCons({
      reflectSymbol: () => "onVisible"
    })(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "productKey"})(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "quantity"})(Restaumatic$dForm$dInternal.addContextRecordNil)(Restaumatic$dForm$dFormField.addContextFormField$p)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dAction.addContextAction)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dAction.addContextAction)()().addContextRecord(Type$dProxy.Proxy)
  })(Restaumatic$dForm$dInternal.makeEmpty_Record()(Restaumatic$dForm$dInternal.makeEmptyRecordCons({reflectSymbol: () => "add"})(Restaumatic$dForm$dInternal.makeEmptyRecordCons({
    reflectSymbol: () => "details"
  })(Restaumatic$dForm$dInternal.makeEmptyRecordCons({reflectSymbol: () => "onVisible"})(Restaumatic$dForm$dInternal.makeEmptyRecordCons({reflectSymbol: () => "productKey"})(Restaumatic$dForm$dInternal.makeEmptyRecordCons({
    reflectSymbol: () => "quantity"
  })(Restaumatic$dForm$dInternal.makeEmptyRecordNil)(Restaumatic$dForm$dFormField.makeEmptyFormField$pPartia)()())(Restaumatic$dForm$dReadOnly.makeEmptyReadOnly)()())(Restaumatic$dForm$dAction.makeEmptyAction)()())(Restaumatic$dForm$dReadOnly.makeEmptyReadOnly)()())(Restaumatic$dForm$dAction.makeEmptyAction)()())))()())(Restaumatic$dForm$dReadOnly.makeEmptyReadOnly)()())(Restaumatic$dForm$dAction.makeEmptyAction)()()).makeEmptyImpl({
    name: ["creatorCrossSelling"]
  }))(v2 => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dHost.liftHost(Specular$dDom$dBuilder.monadCleanupBuilder)(Specular$dInternal$dRIO.monadEffectRIO)(Specular$dInternal$dRIO.bindImpl((() => {
    const $5 = Restaumatic$dForm$dFinal.applicativeFinal.pure(1);
    return v1.subform.defaultValue._2(_old => $5);
  })())(() => Specular$dInternal$dRIO.bindImpl((() => {
    const $5 = Specular$dFRP$dBase.functorDynamic.map(m => {
      if (m.tag === "Left") { return Data$dEither.$Either("Left", m._1); }
      if (m.tag === "Right") { return Data$dEither.$Either("Right", m._1 > 1); }
      $runtime.fail();
    })(Restaumatic$dForm$dFormField.queryFormField$p1(Type$dEquality.refl).queryWith(Restaumatic$dForm$dInternal.Lax)(v1.subform));
    return Data$dRecord.unsafeGet("canDecrease")(v1.extra).value._2(_old => $5);
  })())(() => Specular$dInternal$dRIO.bindImpl((() => {
    const $5 = Restaumatic$dForm$dFormField.modify(v1.subform)(v3 => v3 - 1 | 0);
    return Data$dRecord.unsafeGet("decrease")(v1.extra).effect._2(_old => v$1 => $5);
  })())(() => Specular$dInternal$dRIO.bindImpl((() => {
    const $5 = Restaumatic$dForm$dFormField.modify(v1.subform)(v3 => v3 + 1 | 0);
    return Data$dRecord.unsafeGet("increase")(v1.extra).effect._2(_old => v$1 => $5);
  })())(() => Restaumatic$dSite$dComponents$dCrossSelling.define()()({
    restaurantId: $4,
    menu: $1,
    productIds: Specular$dFRP$dBase.functorDynamic.map(m => {
      if (m.tag === "Left") { return Data$dEither.$Either("Left", m._1); }
      if (m.tag === "Right") { return Data$dEither.$Either("Right", Data$dFunctor.arrayMap(v4 => v4.productId)(m._1)); }
      $runtime.fail();
    })(Restaumatic$dForm$dList.queryArrayList(Restaumatic$dForm$dInternal.query_Record(Restaumatic$dForm$dInternal.asRecordRecord)()(Restaumatic$dForm$dInternal.queryRecordCons({
      reflectSymbol: () => "productId"
    })(Restaumatic$dForm$dInternal.queryRecordNil)(Restaumatic$dForm$dFormField.queryFormField$p1(Type$dEquality.refl))()()()())).queryWith(Restaumatic$dForm$dInternal.Lax)(f.parts)),
    menuOrderOrigin: Restaumatic$dMenu$dV2$dTypes$dOrderOrigin.Online,
    field: v2,
    mode: Restaumatic$dSite$dComponents$dCrossSelling.InternalState,
    menuEnv: $3,
    menuConsumer: $2,
    list: Restaumatic$dAnalytics$dTypes$dItemList.CreatorCrossSelling
  })))))))(() => Specular$dInternal$dRIO.bindImpl(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "canSplit"})(Restaumatic$dForm$dInternal.addContextRecordCons({
    reflectSymbol: () => "customParameters"
  })(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "description"})(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "displayAsParts"})(Restaumatic$dForm$dInternal.addContextRecordCons({
    reflectSymbol: () => "errors"
  })(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "modifiers"})(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "parts"})(Restaumatic$dForm$dInternal.addContextRecordCons({
    reflectSymbol: () => "photo"
  })(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "price"})(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "split"})(Restaumatic$dForm$dInternal.addContextRecordCons({
    reflectSymbol: () => "title"
  })(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "toplevelParameterValues"})(Restaumatic$dForm$dInternal.addContextRecordNil)(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dAction.addContextAction)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dList.addContextList({
    addContext: Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "customParameters"})(Restaumatic$dForm$dInternal.addContextRecordCons({
      reflectSymbol: () => "modifiers"
    })(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "partId"})(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "product"})(Restaumatic$dForm$dInternal.addContextRecordCons({
      reflectSymbol: () => "productId"
    })(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "productSelectorVisible"})(Restaumatic$dForm$dInternal.addContextRecordNil)(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dFormField.addContextFormField$p)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dMapping.addContextMapping((() => {
      const $5 = Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "actualDisplayMode"})(Restaumatic$dForm$dInternal.addContextRecordCons({
        reflectSymbol: () => "decreaseItem"
      })(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "defaultItemOrder"})(Restaumatic$dForm$dInternal.addContextRecordCons({
        reflectSymbol: () => "displayDefaultItems"
      })(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "editable"})(Restaumatic$dForm$dInternal.addContextRecordCons({
        reflectSymbol: () => "editorToggleVisible"
      })(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "editorVisible"})(Restaumatic$dForm$dInternal.addContextRecordCons({
        reflectSymbol: () => "increaseItem"
      })(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "modifierDescription"})(Restaumatic$dForm$dInternal.addContextRecordCons({
        reflectSymbol: () => "modifierName"
      })(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "required"})(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "sections"})(Restaumatic$dForm$dInternal.addContextRecordCons({
        reflectSymbol: () => "selectOnlyItem"
      })(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "setItemSelected"})(Restaumatic$dForm$dInternal.addContextRecordCons({
        reflectSymbol: () => "summaryVisible"
      })(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "toggleEditor"})(Restaumatic$dForm$dInternal.addContextRecordCons({
        reflectSymbol: () => "toggleItem"
      })(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "userEditableWhen"})(Restaumatic$dForm$dInternal.addContextRecordNil)(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dAction.addContextAction)()())(Restaumatic$dForm$dAction.addContextAction)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dAction.addContextAction)()())(Restaumatic$dForm$dAction.addContextAction)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dAction.addContextAction)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dAction.addContextAction)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()().addContextRecord(Type$dProxy.Proxy);
      return {
        addContext: ctx => v$1 => {
          const $6 = v$1.extra;
          const $7 = v$1.subform.context._2(v1$1 => Data$dMap$dInternal.unionWith(Data$dOrd.ordInt)(Data$dFunction.const)(ctx)(v1$1));
          return () => {
            $7();
            return $5(ctx)($6)();
          };
        }
      };
    })()))()())(Restaumatic$dForm$dMapping.addContextMapping(Restaumatic$dForm$dFormField.addContextFormField$p))()().addContextRecord(Type$dProxy.Proxy)
  }))()())(Restaumatic$dForm$dMapping.addContextMapping((() => {
    const $5 = Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "actualDisplayMode"})(Restaumatic$dForm$dInternal.addContextRecordCons({
      reflectSymbol: () => "decreaseItem"
    })(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "defaultItemOrder"})(Restaumatic$dForm$dInternal.addContextRecordCons({
      reflectSymbol: () => "displayDefaultItems"
    })(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "editable"})(Restaumatic$dForm$dInternal.addContextRecordCons({
      reflectSymbol: () => "editorToggleVisible"
    })(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "editorVisible"})(Restaumatic$dForm$dInternal.addContextRecordCons({
      reflectSymbol: () => "increaseItem"
    })(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "modifierDescription"})(Restaumatic$dForm$dInternal.addContextRecordCons({
      reflectSymbol: () => "modifierName"
    })(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "required"})(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "sections"})(Restaumatic$dForm$dInternal.addContextRecordCons({
      reflectSymbol: () => "selectOnlyItem"
    })(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "setItemSelected"})(Restaumatic$dForm$dInternal.addContextRecordCons({
      reflectSymbol: () => "summaryVisible"
    })(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "toggleEditor"})(Restaumatic$dForm$dInternal.addContextRecordCons({reflectSymbol: () => "toggleItem"})(Restaumatic$dForm$dInternal.addContextRecordCons({
      reflectSymbol: () => "userEditableWhen"
    })(Restaumatic$dForm$dInternal.addContextRecordNil)(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dAction.addContextAction)()())(Restaumatic$dForm$dAction.addContextAction)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dAction.addContextAction)()())(Restaumatic$dForm$dAction.addContextAction)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dAction.addContextAction)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dAction.addContextAction)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()().addContextRecord(Type$dProxy.Proxy);
    return {
      addContext: ctx => v$1 => {
        const $6 = v$1.extra;
        const $7 = v$1.subform.context._2(v1$1 => Data$dMap$dInternal.unionWith(Data$dOrd.ordInt)(Data$dFunction.const)(ctx)(v1$1));
        return () => {
          $7();
          return $5(ctx)($6)();
        };
      }
    };
  })()))()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()())(Restaumatic$dForm$dMapping.addContextMapping(Restaumatic$dForm$dFormField.addContextFormField$p))()())(Restaumatic$dForm$dReadOnly.addContextReadOnly)()().addContextRecord(Type$dProxy.Proxy)(Data$dMap$dInternal.insert(Data$dOrd.ordInt)(Restaumatic$dForm$dInternal.forceDisplayErrorsKey)(submittedRef._1)(Data$dMap$dInternal.Leaf))(f))(() => {
    const titleD = Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dFinal.fromValidV)(Restaumatic$dForm$dReadOnly.queryReadOnly$p1(Type$dEquality.refl).queryWith(Restaumatic$dForm$dInternal.Lax)(f.title));
    return Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("m-product-card__header")])(Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dReplaceable.whenJustD(Specular$dDom$dBuilder.monadReplaceBuilder)({
      MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
      MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
    })(Specular$dFRP$dBase.functorDynamic.map(v1$1 => {
      if (v1$1.tag === "Just") {
        return Data$dMaybe.$Maybe("Just", Utils$dURL.setQueryParams([Data$dTuple.$Tuple("auto", "compress"), Data$dTuple.$Tuple("w", "600")])(Utils$dURL.imgixUrl + v1$1._1));
      }
      return Data$dMaybe.Nothing;
    })(Restaumatic$dForm$dInternal.queryLaxWithDefault(Restaumatic$dForm$dReadOnly.queryReadOnly$p1(Type$dEquality.refl))(Data$dMaybe.Nothing)(f.photo)))(photo => Specular$dDom$dElement.el("img")([
      Specular$dDom$dElement.class_("m-product-card__img"),
      Specular$dDom$dElement.attrD("src")(photo)
    ])(Restaumatic$dPrelude$dSpecular.wempty)))(() => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("m-product-card__actions")])(Specular$dDom$dElement.el("button")([
      Specular$dDom$dElement.attrs(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
        const $5 = {};
        $5.type = "button";
        return $5;
      })())(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
        const $5 = {};
        $5.class = "m-product-card__action-btn u-btn-unstyled";
        return $5;
      })())(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
        const $5 = {};
        $5["data-bs-dismiss"] = "modal";
        return $5;
      })())((() => {
        const $5 = Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.modal.close), {});
        return (() => {
          const $6 = {};
          $6["aria-label"] = $5;
          return $6;
        })();
      })()))))
    ])(Specular$dDom$dElement.el("span")([
      Specular$dDom$dElement.attrs(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
        const $5 = {};
        $5.class = "icon-cancel icon-flex-center";
        return $5;
      })())((() => {
        const $5 = {};
        $5["aria-hidden"] = "true";
        return $5;
      })()))
    ])(Restaumatic$dPrelude$dSpecular.wempty))))))(() => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dBase.subscribeDyn_({
      MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
      MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
    })(Utils$dHash.replaceHash(Effect$dClass.monadEffectEffect))(Restaumatic$dForm$dInternal.unFinalWithDefault("")(Specular$dFRP$dBase.functorDynamic.map(m => {
      if (m.tag === "Left") { return Data$dEither.$Either("Left", m._1); }
      if (m.tag === "Right") { return Data$dEither.$Either("Right", "#product/" + Data$dString$dCommon.joinWith("/")(Data$dFunctor.arrayMap(x => x.productId)(m._1))); }
      $runtime.fail();
    })(Restaumatic$dForm$dList.queryArrayList(Restaumatic$dForm$dInternal.query_Record(Restaumatic$dForm$dInternal.asRecordRecord)()(Restaumatic$dForm$dInternal.queryRecordCons({
      reflectSymbol: () => "productId"
    })(Restaumatic$dForm$dInternal.queryRecordNil)(Restaumatic$dForm$dFormField.queryFormField$p1(Type$dEquality.refl))()()()())).queryWith(Restaumatic$dForm$dInternal.Lax)(f.parts)))))(() => {
      const onlyProductD = Restaumatic$dForm$dInternal.unFinalWithDefault(Data$dMaybe.Nothing)(Specular$dFRP$dBase.functorDynamic.map(m => {
        if (m.tag === "Left") { return Data$dEither.$Either("Left", m._1); }
        if (m.tag === "Right") { return Data$dEither.$Either("Right", m._1.length === 1 ? Data$dMaybe.$Maybe("Just", m._1[0]) : Data$dMaybe.Nothing); }
        $runtime.fail();
      })(Restaumatic$dForm$dList.queryArrayList(Restaumatic$dForm$dInternal.query_Record(Restaumatic$dForm$dInternal.asRecordRecord)()(Restaumatic$dForm$dInternal.queryRecordCons({
        reflectSymbol: () => "product"
      })(Restaumatic$dForm$dInternal.queryRecordCons({reflectSymbol: () => "productId"})(Restaumatic$dForm$dInternal.queryRecordNil)(Restaumatic$dForm$dFormField.queryFormField$p1(Type$dEquality.refl))()()()())(Restaumatic$dForm$dReadOnly.queryReadOnly$p1(Type$dEquality.refl))()()()())).queryWith(Restaumatic$dForm$dInternal.Lax)(f.parts)));
      return Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("m-product-card__body")])(Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dReplaceable.withDynamic_(Specular$dDom$dBuilder.monadReplaceBuilder)({
        MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
        MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
      })(onlyProductD)((() => {
        const $5 = Specular$dInternal$dRIO.pureImpl();
        return v1$1 => {
          if (v1$1.tag === "Nothing") { return $5; }
          if (v1$1.tag === "Just") {
            const $6 = v1$1._1.product;
            return Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v$1 => x => x)(Specular$dDom$dElement.el("div")([
              Specular$dDom$dElement.class_("m-product-card__details")
            ])(Specular$dInternal$dRIO.bindImpl(productInfoChips($6))(() => productAvailablityWidget(localDateTime)(catalogue)($6)))))($5);
          }
          $runtime.fail();
        };
      })()))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("h3")([Specular$dDom$dElement.classes(["m-product-card__title", "u-my2"])])(Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dBase.latestJust({
        MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
        MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
      })(titleD))(title$p => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.dynText(Specular$dFRP$dBase.functorDynamic.map((() => {
        const $5 = Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.menu.creator.defaultTitle), {});
        return v2$1 => {
          if (v2$1.tag === "Nothing") { return $5; }
          if (v2$1.tag === "Just") { return v2$1._1; }
          $runtime.fail();
        };
      })())(title$p)))(() => Specular$dFRP$dReplaceable.withDynamic_(Specular$dDom$dBuilder.monadReplaceBuilder)({
        MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
        MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
      })(onlyProductD)((() => {
        const $5 = Specular$dInternal$dRIO.pureImpl();
        return v1$1 => {
          if (v1$1.tag === "Nothing") { return $5; }
          if (v1$1.tag === "Just") { return Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v$1 => x => x)(dishIcons(v1$1._1.product)))($5); }
          $runtime.fail();
        };
      })())))))(() => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dReplaceable.withDynamic_(Specular$dDom$dBuilder.monadReplaceBuilder)({
        MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
        MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
      })(onlyProductD)((() => {
        const $5 = Specular$dInternal$dRIO.pureImpl();
        return v1$1 => {
          if (v1$1.tag === "Nothing") { return $5; }
          if (v1$1.tag === "Just") {
            const $6 = v1$1._1.productId;
            return Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v$1 => x => x)(Specular$dDom$dElement.el("div")([
              Specular$dDom$dElement.class_("m-product-card__desc")
            ])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("p")([Specular$dDom$dElement.class_("u-small-spacing-b")])(Specular$dDom$dElement.text(Restaumatic$dI18n$dTypes.getLocalization(locale)(Data$dRecord.unsafeGet("description")(v1$1._1.product)))))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(" "))(() => Specular$dDom$dElement.el("p")([
              Specular$dDom$dElement.class_("u-small-spacing-b")
            ])(Specular$dDom$dElement.text(Restaumatic$dMenu$dV2$dMenuCatalogue.productDefaultDisplayedSelectionString(locale)(catalogue)($6))))))))($5);
          }
          $runtime.fail();
        };
      })()))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("hr")([Specular$dDom$dElement.class_("m-hr")])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dDom$dElement.el("form")([
        Specular$dDom$dElement.class_("m-form")
      ])(Specular$dInternal$dRIO.bindImpl(contentView({catalogue, menuEnv: $3})(f))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("hr")([
        Specular$dDom$dElement.class_("m-hr")
      ])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("fieldset")([Specular$dDom$dElement.class_("m-form__group")])(Specular$dDom$dElement.el("div")([
        Specular$dDom$dElement.class_("d-flex justify-content-center align-items-center")
      ])(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("m-modifier-item__stepper")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("button")([
        Specular$dDom$dElement.class_("m-modifier-item__btn"),
        Specular$dDom$dElement.attr("type")("button"),
        Specular$dDom$dElement.attrUnlessD(Restaumatic$dForm$dInternal.queryLaxWithDefault(Restaumatic$dForm$dReadOnly.queryReadOnly$p1(Type$dEquality.refl))(false)(Data$dRecord.unsafeGet("canDecrease")(v1.extra)))("disabled")("disabled"),
        Restaumatic$dPrelude$dSpecularExtra.onClickPreventDefault_(Restaumatic$dForm$dAction.trigger(Data$dRecord.unsafeGet("decrease")(v1.extra)))
      ])(Specular$dDom$dElement.el("span")([
        Specular$dDom$dElement.attrs(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
          const $5 = {};
          $5.class = "icon-minus icon-flex-center";
          return $5;
        })())((() => {
          const $5 = {};
          $5["aria-hidden"] = "true";
          return $5;
        })()))
      ])(Restaumatic$dPrelude$dSpecular.wempty)))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([Specular$dDom$dElement.class_("m-modifier-item__count")])(Specular$dDom$dElement.dynText(Specular$dFRP$dBase.functorDynamic.map(v2$1 => {
        if (v2$1.tag === "Nothing") { return ""; }
        if (v2$1.tag === "Just") { return Data$dShow.showIntImpl(v2$1._1); }
        $runtime.fail();
      })(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dFinal.fromValidV)(Restaumatic$dForm$dFormField.queryFormField$p1(Type$dEquality.refl).queryWith(Restaumatic$dForm$dInternal.Lax)(v1.subform))))))(() => Specular$dDom$dElement.el("button")([
        Specular$dDom$dElement.class_("m-modifier-item__btn"),
        Specular$dDom$dElement.attr("type")("button"),
        Restaumatic$dPrelude$dSpecularExtra.onClickPreventDefault_(Restaumatic$dForm$dAction.trigger(Data$dRecord.unsafeGet("increase")(v1.extra)))
      ])(Specular$dDom$dElement.el("span")([
        Specular$dDom$dElement.attrs(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
          const $5 = {};
          $5.class = "icon-plus icon-flex-center";
          return $5;
        })())((() => {
          const $5 = {};
          $5["aria-hidden"] = "true";
          return $5;
        })()))
      ])(Restaumatic$dPrelude$dSpecular.wempty))))))))(() => Restaumatic$dSite$dComponents$dCrossSelling.display()()({field: v2})))))))))))(() => Specular$dDom$dElement.el("div")([
        Specular$dDom$dElement.classes(["modal-footer", "modal-footer--sticky"])
      ])(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["modal-footer__actions", "modal-footer__actions--ssm-regular"])])(Specular$dDom$dElement.el("button")([
        Specular$dDom$dElement.classes(["btn", "btn-primary"]),
        Specular$dDom$dElement.attr("type")("button"),
        Specular$dDom$dElement.attr("data-testid")("Creator/finish"),
        Specular$dDom$dElement.onClick_((() => {
          const $5 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(Record$dExtra.sequenceRecord()(Record$dExtra.sequenceRecordCons({
            reflectSymbol: () => "crossSellingProducts"
          })()(Restaumatic$dForm$dFinal.applyFinal)(Record$dExtra.sequenceRecordSingle({reflectSymbol: () => "mainProduct"})()(Restaumatic$dForm$dFinal.functorFinal)()())()())({
            mainProduct: Specular$dFRP$dBase.functorDynamic.map(m => {
              if (m.tag === "Left") { return Data$dEither.$Either("Left", m._1); }
              if (m.tag === "Right") {
                return Data$dEither.$Either(
                  "Right",
                  {product: {key: Restaumatic$dCart$dProductKey.$ProductKey("MenuProduct", m._1.productKey), note: Data$dMaybe.Nothing}, quantity: m._1.quantity}
                );
              }
              $runtime.fail();
            })(Record$dExtra.sequenceRecord()(Record$dExtra.sequenceRecordCons({reflectSymbol: () => "productKey"})()(Restaumatic$dForm$dFinal.applyFinal)(Record$dExtra.sequenceRecordSingle({
              reflectSymbol: () => "quantity"
            })()(Restaumatic$dForm$dFinal.functorFinal)()())()())({
              productKey: Restaumatic$dForm$dInternal.query_Record({fromRecord: Unsafe$dCoerce.unsafeCoerce, toRecord: Unsafe$dCoerce.unsafeCoerce})()(Restaumatic$dForm$dInternal.queryRecordCons({
                reflectSymbol: () => "customParameters"
              })(Restaumatic$dForm$dInternal.queryRecordCons({reflectSymbol: () => "modifiers"})(Restaumatic$dForm$dInternal.queryRecordCons({reflectSymbol: () => "parts"})(Restaumatic$dForm$dInternal.queryRecordNil)(Restaumatic$dForm$dList.queryNewtypeList()(Restaumatic$dForm$dList.queryNonEmptyArrayList(Restaumatic$dForm$dList.queryArrayList(Restaumatic$dForm$dInternal.query_Record({
                fromRecord: Unsafe$dCoerce.unsafeCoerce,
                toRecord: Unsafe$dCoerce.unsafeCoerce
              })()(Restaumatic$dForm$dInternal.queryRecordCons({reflectSymbol: () => "customParameters"})(Restaumatic$dForm$dInternal.queryRecordCons({
                reflectSymbol: () => "modifiers"
              })(Restaumatic$dForm$dInternal.queryRecordCons({reflectSymbol: () => "productId"})(Restaumatic$dForm$dInternal.queryRecordNil)(Restaumatic$dForm$dFormField.queryFormField$p1(Type$dEquality.refl))()()()())(Restaumatic$dForm$dMapping.querySerializedMapMapping(Data$dOrd.ordString)((() => {
                const $5 = Restaumatic$dForm$dFormField.queryFormField$p1(Type$dEquality.refl);
                return {
                  queryWith: s => {
                    const $6 = $5.queryWith(s);
                    return x => $6(x.subform);
                  }
                };
              })()))()()()())(Restaumatic$dForm$dMapping.querySerializedMapMapping(Data$dOrd.ordString)(Restaumatic$dForm$dFormField.queryFormField$p1(Type$dEquality.refl)))()()()())))))()()()())(Restaumatic$dForm$dMapping.querySerializedMapMapping(Data$dOrd.ordString)((() => {
                const $5 = Restaumatic$dForm$dFormField.queryFormField$p1(Type$dEquality.refl);
                return {
                  queryWith: s => {
                    const $6 = $5.queryWith(s);
                    return x => $6(x.subform);
                  }
                };
              })()))()()()())(Restaumatic$dForm$dMapping.querySerializedMapMapping(Data$dOrd.ordString)(Restaumatic$dForm$dFormField.queryFormField$p1(Type$dEquality.refl)))()()()()).queryWith(Restaumatic$dForm$dInternal.Strict)(f),
              quantity: Restaumatic$dForm$dFormField.queryFormField$p1(Type$dEquality.refl).queryWith(Restaumatic$dForm$dInternal.Strict)(v1.subform)
            })),
            crossSellingProducts: Specular$dFRP$dBase.functorDynamic.map(Data$dEither.functorEither.map(Data$dFunctor.arrayMap(v3 => (
              {product: {key: Restaumatic$dCart$dProductKey.$ProductKey("MenuProduct", v3.productKey), note: Data$dMaybe.Nothing}, quantity: v3.quantity}
            ))))(Restaumatic$dForm$dReadOnly.queryReadOnly$p1(Type$dEquality.refl).queryWith(Restaumatic$dForm$dInternal.Strict)(v2.result))
          }));
          return () => {
            const v_result = $5();
            submittedRef._2(_old => true)();
            if (v_result.tag === "Left") { return; }
            if (v_result.tag === "Right") {
              const $6 = v_result._1;
              const e = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(v2.finished.effect._1)();
              e()();
              const fiber = Effect$dAff._makeFiber(
                Effect$dAff.ffiUtil,
                Effect$dAff._bind(Effect$dAff._liftEffect(Restaumatic$dSite$dModals.setNextModalShouldReplaceHash))(() => Effect$dAff._bind(Specular$dFRP$dBase.readDynamic(Effect$dAff.monadEffectAff)(modalR._1))(modalNode => Effect$dAff._bind((() => {
                  const $7 = Effect$dAff._pure();
                  if (modalNode.tag === "Nothing") { return $7; }
                  if (modalNode.tag === "Just") { return Effect$dAff.applyAff.apply(Effect$dAff._map(v$1 => x => x)(Specular$dBootstrap$dModal.hideModalBs5(modalNode._1)))($7); }
                  $runtime.fail();
                })())(() => Effect$dAff._liftEffect(v.onFinish($6)))))
              )();
              fiber.run();
              return;
            }
            $runtime.fail();
          };
        })())
      ])(Specular$dDom$dElement.dynText(Specular$dFRP$dBase.functorDynamic.map(v3 => Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.creator.add_to_cart),
        {}
      ) + (() => {
        if (v3.tag === "Just") { return " (" + Restaumatic$dI18n$dCurrency.formatCurrency(Restaumatic$dSite$dI18n.getGlobalCurrency())(v3._1) + ")"; }
        if (v3.tag === "Nothing") { return ""; }
        $runtime.fail();
      })())(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dFinal.fromValidV)(Restaumatic$dForm$dFinal.additiveFinal(Data$dMoney$dRounded.additiveMoney).add(Restaumatic$dForm$dFinal.applyFinal.apply(Specular$dFRP$dBase.functorDynamic.map(Data$dEither.functorEither.map(Data$dMoney$dRounded.scaleIntMoney.scale))(Restaumatic$dForm$dFormField.queryFormField$p1(Type$dEquality.refl).queryWith(Restaumatic$dForm$dInternal.Strict)(v1.subform)))(Restaumatic$dForm$dReadOnly.queryReadOnly$p1(Type$dEquality.refl).queryWith(Restaumatic$dForm$dInternal.Strict)(f.price)))(Restaumatic$dForm$dReadOnly.queryReadOnly$p1(Type$dEquality.refl).queryWith(Restaumatic$dForm$dInternal.Strict)(v2.total)))))))));
    }));
  }))))))));
};
const init = /* #__PURE__ */ Specular$dInternal$dRIO.bindImpl(/* #__PURE__ */ Specular$dRef.new(Specular$dInternal$dRIO.monadEffectRIO)(Data$dMaybe.Nothing))(currentRequest => Specular$dInternal$dRIO.bindImpl(Specular$dRef.new(Specular$dInternal$dRIO.monadEffectRIO)(Data$dMaybe.Nothing))(v => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el$p("div")([
  Specular$dDom$dElement.classes(["m-product-card", "modal", "fade", "creator", "js-menuv2-product-creator", "js-popover-container"]),
  Specular$dDom$dElement.attr("id")("product-creator"),
  Specular$dDom$dElement.attr("role")("dialog"),
  Specular$dDom$dElement.attr("tabindex")("-1")
])(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["modal-dialog"])])(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("modal-content")])(Specular$dFRP$dReplaceable.withDynamic_(Specular$dDom$dBuilder.monadReplaceBuilder)({
  MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
  MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
})(currentRequest._1)((() => {
  const $0 = Specular$dInternal$dRIO.pureImpl();
  return v1 => {
    if (v1.tag === "Nothing") { return $0; }
    if (v1.tag === "Just") { return Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v$1 => x => x)(creator(v1._1)(v)))($0); }
    $runtime.fail();
  };
})())))))(v1 => {
  const $0 = v1._1;
  return Specular$dInternal$dRIO.bindImpl(v._2(_old => Data$dMaybe.$Maybe("Just", $0)))(() => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dBase.subscribeDyn_({
    MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
    MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
  })(v1$1 => {
    if (v1$1.tag === "Nothing") { return () => {}; }
    if (v1$1.tag === "Just") {
      const $1 = Effect$dAff._makeFiber(Effect$dAff.ffiUtil, Specular$dBootstrap$dModal.showModalBs5($0));
      return () => {
        const fiber = $1();
        fiber.run();
      };
    }
    $runtime.fail();
  })(currentRequest._1))(() => Specular$dInternal$dRIO.pureImpl({open: x => currentRequest._2(_old => Data$dMaybe.$Maybe("Just", x))})));
})));
const initStandalone = () => {
  const body = Specular$dDom$dWidget.documentBody();
  const a$p = Specular$dDom$dWidget.runWidgetInNode(body)(init)();
  return a$p._1;
};
export {
  contentView,
  creator,
  dishIcons,
  displayModifierChoices,
  effectCallback,
  emptyMenuEnv,
  hideModal,
  init,
  initStandalone,
  modifierButtons,
  modifiersField,
  onClickD,
  parameterRadioButtons,
  parametersField,
  productAvailablityWidget,
  productInfoChips
};
export * from "./foreign.js";
